import { cloneDeep } from 'lodash';
import { HTMLAttributes } from 'react';
import { useSvgModel } from '@/store/models/svg-model';
import BorderSize from '../components/border-size';
import Colors from '../components/colors';
import Ellipse from '../components/ellipse';
import Rect from '../components/rect';
import Shapes from '../components/shape';
// import Line from '../components/Line';
import { SVG_ATTR_ENUM } from '../types';
import './index.less';

interface IProps extends HTMLAttributes<HTMLDivElement> {}

const Panel: React.FC<IProps> = () => {
    const svgInfo = useSvgModel((state) => state.svgConfig);
    const curShape = useSvgModel((state) => state.curShape);
    const setSvgConfig = useSvgModel((state) => state.setSvgConfig);

    console.log(svgInfo, 'svgInfo');

    const handlePanelClick = (key: SVG_ATTR_ENUM, val: any) => {
        const config = cloneDeep(svgInfo);

        key === SVG_ATTR_ENUM.STROKE_WIDTH
            ? (config[curShape]['stroke-width'] = val)
            : ((config as any)[curShape][key] = val);
        setSvgConfig(config);
    };

    return (
        <div className="design-svg-panel">
            <Shapes svgInfo={svgInfo} curShape={curShape} />
            <div className="design-svg-operate">
                <Colors
                    title="填充颜色"
                    color={svgInfo[curShape].fill}
                    onClick={(color) => handlePanelClick(SVG_ATTR_ENUM.FILL, color)}
                />
                <Colors
                    title="边框颜色"
                    color={svgInfo[curShape].stroke}
                    onClick={(color) => handlePanelClick(SVG_ATTR_ENUM.STROKE_COLOR, color)}
                />
                <BorderSize
                    title="边框尺寸"
                    size={svgInfo[curShape]['stroke-width']}
                    onClick={(val) => handlePanelClick(SVG_ATTR_ENUM.STROKE_WIDTH, val)}
                />

                <Rect OnClick={handlePanelClick} />
                <Ellipse OnClick={handlePanelClick} />
                {/* <Line OnClick={handlePanelClick} /> */}
            </div>
        </div>
    );
};
export default Panel;
